import React, { useState } from "react";
import { Carousel, Card, Modal } from "react-bootstrap";
import ReactPlayer from "react-player";
import PlaceholderImage from "../../sharedComponents/placeholderImage";
import CenteredLoadingIndicator from "../../sharedComponents/centeredLoadingIndicator";
import NoImage from "../../assets/images/logo_motivation.png";
import "./home.scss";

export default function AdCarousel({ ads, height = "auto", componentIdentifier }) {
	const [show, setShow] = useState(false);
	const [selectedAdDetails, setSelectedAdDetails] = useState({});

	const handleClose = () => setShow(false);
	const handleShow = (item) => {
		setSelectedAdDetails(item);
		setShow(true);
	};

	const adModal = (selectedAdDetails, show) => {
		const adType = selectedAdDetails.video === null ? "image" : "video";
		return (
			<Modal show={show} onHide={handleClose} centered>
				<Modal.Header closeButton>
					<Modal.Title>{selectedAdDetails.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{adType === "video" ? (
						<ReactPlayer url={selectedAdDetails.video} playing controls width="100%" />
					) : (
						<PlaceholderImage
							src={selectedAdDetails.image}
							width="100%"
							height="100%"
							bg="rgba(0,0,0,0.1)"
							color="rgba(0,0,0,0.3)"
							objectFit="contain"
							className="mr-3"
						/>
					)}
				</Modal.Body>

				{componentIdentifier === "ad" && selectedAdDetails.url && (
					<Modal.Footer>
						<a href={selectedAdDetails.url} target="_blank" rel="noopener noreferrer">
							Click here for details
						</a>
					</Modal.Footer>
				)}
			</Modal>
		);
	};

	const getVideoImage = (item) => {
		return item.youtube_id && item.youtube_id !== "" ? `https://img.youtube.com/vi/${item.youtube_id}/0.jpg` : NoImage;
	};

	return (
		<React.Fragment>
			<Card style={{ height }} className="ad-carousel-main-container">
				{ads ? (
					ads.length ? (
						<Carousel
							fade={true}
							style={{ height }}
							interval={null}
							prevIcon={<i className="icon icon-angle-left" />}
							nextIcon={<i className="icon icon-angle-right" />}>
							{ads.map((item) => {
								const adType = item.video === null ? "image" : "video";
								const image = item.video === null ? item.image : getVideoImage(item);
								return (
									<Carousel.Item key={item.id}>
										<div style={{ position: "relative", padding: 0, margin: 0 }}>
											<div onClick={() => handleShow(item)}>
												<PlaceholderImage
													src={image}
													width="100%"
													height={height}
													bg="rgba(0,0,0,0.1)"
													color="rgba(0,0,0,0.3)"
													objectFit="contain"
													className="img-custom-style pointer"
												/>
											</div>
											{adType === "video" && item.youtube_id && (
												<div onClick={() => handleShow(item)} className="centered-container">
													<PlaceholderImage
														src={require("../../assets/images/youtube icon.png")}
														width="50"
														height="35"
														bg="rgba(0,0,0,0.1)"
														color="rgba(0,0,0,0.3)"
														objectFit="cover"
														className="pointer"
													/>
												</div>
											)}
										</div>
									</Carousel.Item>
								);
							})}
						</Carousel>
					) : (
						<PlaceholderImage
							src={require("../../assets/images/no-ad-found.png")}
							width="100%"
							height="100%"
							className="mr-3"
							bg="rgba(0,0,0,0.1)"
							color="rgba(0,0,0,0.3)"
							objectFit="contain"
						/>
					)
				) : (
					<CenteredLoadingIndicator />
				)}
			</Card>
			{adModal(selectedAdDetails, show)}
		</React.Fragment>
	);
}
